var render = function () {
  var _vm$memberData$total_, _vm$memberData$total_2, _vm$memberData$total_3, _vm$memberData$averag, _vm$memberData$averag2, _vm$memberData$averag3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper rep-dashboard-wrapper enrollprime-dashboard"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row align-items-end"
  }, [_c('div', {
    staticClass: "col-12 sectionTitle manage-business-title mb-4"
  }, [_c('h5', {
    staticClass: "title-section mb-2 mb-md-0"
  }, [_vm._v("Manage Business")]), _c('div', {
    staticClass: "d-flex align-items-center location-filter gap-2"
  }, [_c('label', {
    attrs: {
      "for": "locationFilter"
    }
  }, [_vm._v(" View by Location: ")]), _c('multiselect', {
    staticClass: "form-select-custom",
    attrs: {
      "id": "locationFilter",
      "options": _vm.locationOptions,
      "searchable": false,
      "show-labels": false,
      "placeholder": "All Locations",
      "track-by": "value",
      "allow-empty": false,
      "close-on-select": true,
      "max-height": 250,
      "label": "label"
    },
    model: {
      value: _vm.selectedLocation,
      callback: function callback($$v) {
        _vm.selectedLocation = $$v;
      },
      expression: "selectedLocation"
    }
  })], 1)]), _c('div', {
    staticClass: "col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-4"
  }, [_c('h5', {
    staticClass: "title-section"
  }, [_vm._v("Manage Business")]), _c('div', {
    staticClass: "overallInfo-blockWrapper rep-dash p-3 noHeight"
  }, [_c('div', {
    staticClass: "manage-btn "
  }, [_c('button', {
    on: {
      "click": function click($event) {
        return _vm.routeToLink('/view-members');
      }
    }
  }, [_vm._v("Members")]), _vm.isDownlineHasAccess ? _c('button', {
    staticClass: "mb-0",
    on: {
      "click": function click($event) {
        return _vm.routeToLink('/view-downline-reps');
      }
    }
  }, [_vm._v(" Downline Reps ")]) : _vm._e()])])]), _c('div', {
    staticClass: "col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-4"
  }, [_c('div', {
    staticClass: "overallInfo-blockWrapper p-2 no-margin-bottom",
    staticStyle: {
      "padding-bottom": "0",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "dataBlock-active"
  }, [_vm._m(0), _c('div', [_c('span', [_vm._v("Total Active")]), _c('h3', [_vm._v(_vm._s((_vm$memberData$total_ = _vm.memberData.total_active) !== null && _vm$memberData$total_ !== void 0 ? _vm$memberData$total_ : 0))])])]), _c('div', {
    staticClass: "dataBlock-termed"
  }, [_vm._m(1), _c('div', [_c('span', [_vm._v("Total Termed")]), _c('h3', [_vm._v(_vm._s((_vm$memberData$total_2 = _vm.memberData.total_termed) !== null && _vm$memberData$total_2 !== void 0 ? _vm$memberData$total_2 : 0))])])]), _c('div', {
    staticClass: "dataBlock-withdrawn"
  }, [_vm._m(2), _c('div', [_c('span', [_vm._v("Total Withdrawn")]), _c('h3', [_vm._v(_vm._s((_vm$memberData$total_3 = _vm.memberData.total_withdraw) !== null && _vm$memberData$total_3 !== void 0 ? _vm$memberData$total_3 : 0))])])])])])]), _c('div', {
    staticClass: "col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-4"
  }, [_c('div', {
    staticClass: "overallInfo-blockWrapper p-2 no-margin-bottom",
    staticStyle: {
      "padding-bottom": "0",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center "
  }, [_c('div', {
    staticClass: "dataBlock-average-age"
  }, [_vm._m(3), _c('div', [_c('span', [_vm._v("Avg. Age")]), _c('h3', [_vm._v(_vm._s((_vm$memberData$averag = _vm.memberData.average_age) !== null && _vm$memberData$averag !== void 0 ? _vm$memberData$averag : 0))])])]), _c('div', {
    staticClass: "dataBlock-average-premium"
  }, [_vm._m(4), _c('div', [_c('span', [_vm._v("Avg. Premium")]), _c('h3', [_vm._v(_vm._s((_vm$memberData$averag2 = _vm.memberData.average_premium) !== null && _vm$memberData$averag2 !== void 0 ? _vm$memberData$averag2 : 0))])])]), _c('div', {
    staticClass: "dataBlock-average-lifespan"
  }, [_vm._m(5), _c('div', [_c('span', [_vm._v("Avg. Lifespan")]), _c('h3', [_vm._v(_vm._s((_vm$memberData$averag3 = _vm.memberData.average_lifespan) !== null && _vm$memberData$averag3 !== void 0 ? _vm$memberData$averag3 : 0))])])])])])]), _c('div', {
    staticClass: "col-xxl-3 col-xl-4 col-lg-6 col-md-6 vue-custom-scrollbar"
  }, [_c('pending-items', {
    staticStyle: {
      "height": "140px"
    },
    attrs: {
      "title": false
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-12 mb-3"
  }, [_c('div', {
    staticClass: "sectionTitle"
  }, [_c('h5', {
    staticClass: "title-section"
  }, [_vm._v("Overall Enrollment Analytics")]), _c('div', {
    staticClass: "d-flex granFilter align-items-center mb-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Filter Via:")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedFilter,
      expression: "selectedFilter"
    }],
    staticClass: "form-select",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.updateChart]
    }
  }, [_c('option', [_vm._v("Yearly")]), _c('option', [_vm._v("Weekly")]), _c('option', [_vm._v("Monthly")]), _c('option', [_vm._v("Last Week")]), _c('option', [_vm._v("Last 30 Days")])])])]), _c('div', {
    staticClass: "overallInfo-blockWrapper noHeight p-3 ps-2 pb-2"
  }, [_c('apexchart', {
    attrs: {
      "type": "area",
      "height": "350",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_vm.memberData.top_states ? _c('state-enroll-table-data', {
    attrs: {
      "memberDataByStates": _vm.memberData.top_states
    }
  }) : _vm._e(), _c('tier-enroll-table-data', {
    attrs: {
      "memberDataByTier": _vm.memberData.by_tier
    }
  }), _c('termination-withdrawn', {
    attrs: {
      "sorted-list": _vm.topReasons
    }
  })], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "iconBlock"
  }, [_c('i', {
    staticClass: "fas fa-user-check"
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "iconBlock"
  }, [_c('i', {
    staticClass: "fas fa-user-slash"
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "iconBlock"
  }, [_c('i', {
    staticClass: "fas fa-user-times"
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "iconBlock"
  }, [_c('i', {
    staticClass: "fas fa-id-card"
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "iconBlock"
  }, [_c('i', {
    staticClass: "fas fa-dollar-sign"
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "iconBlock"
  }, [_c('i', {
    staticClass: "fas fa-heartbeat"
  })]);
}]

export { render, staticRenderFns }